import {
    DELETE_USER_SETTINGS,IS_LOADING_LIST_OF_USER_SETTINGS,CREATE_USER_SETTINGS,EDIT_USER_SETTINGS, LIST_OF_USER_SETTINGS
 } from '../actions/types'
 
 const initialState = {
  
     isLoadingListUserSettings:false,
     listUserSettings:[],
 
 }
  
 export default function (state = initialState, action) {
     switch (action.type) {
 
 case IS_LOADING_LIST_OF_USER_SETTINGS:
     return { ...state, isLoadingListUserSettings: true }
 case  CREATE_USER_SETTINGS:
     var addUserSetting = Array.from(state.listUserSettings)
     addUserSetting.push(action.payload)
     return { ...state, listUserSettings: addUserSetting, isLoadingListUserSettings: false } 
 case EDIT_USER_SETTINGS:
     console.log()
     var editUserSetting = state.listUserSettings
     editUserSetting[action.payload.index] = action.payload.data
     return { ...state, listUserSettings: editUserSetting, isLoadingListUserSettings: false }
 case LIST_OF_USER_SETTINGS:
     return { ...state, isLoadingListUserSettings: false, listUserSettings: action.payload }
 case DELETE_USER_SETTINGS:
     var deleteUserSetting = state.listUserSettings
     deleteUserSetting.splice(action.payload, 1)
     return { ...state, isLoadingListUserSettings: false, listUserSettings: deleteUserSetting }
     default:
         return state
 
 }
 }
 
 